import { render } from "./authIcon.vue?vue&type=template&id=4246ab90"
import script from "./authIcon.vue?vue&type=script&lang=js"
export * from "./authIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__